import { LockOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React, { useState } from 'react'
import { BodyText, H3 } from 'src/branding/typography'
import FadeIn from 'src/components/styled/FadeIn'
import { Center } from 'src/components/styled/FlexBox'
import styled from 'styled-components/macro'
import RolePermissionsModal from 'src/components/RolePermissionsModal'

const PermissionBlockScreen = ({ description = null }) => {
  const [showRoleModal, setShowRoleModal] = useState(false)

  return (
    <>
      <Wrapper>
        <Card>
          <LockOutlined
            style={{
              fontSize: 75,
              color: '#999',
              marginBottom: '16px',
            }}
          />
          <H3>You don&apos;t have access to this page</H3>
          <BodyText
            textAlign='center'
            style={{ maxWidth: '500px', marginBottom: '24px' }}
          >
            {description || (
              <>
                Oops! This page is off-limits for your role. Don&apos;t worry
                though—you can still do plenty of other things. Ask an Admin to
                upgrade your role if you need access to this feature.
              </>
            )}
          </BodyText>
          <LearnAboutRolesButton
            type='primary'
            onClick={() => setShowRoleModal(true)}
          >
            Learn about roles
          </LearnAboutRolesButton>
        </Card>
      </Wrapper>
      <RolePermissionsModal
        visible={showRoleModal}
        onCancel={() => setShowRoleModal(false)}
      />
    </>
  )
}

const Wrapper = styled(FadeIn)``

const Card = styled(Center)`
  flex-direction: column;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colours.mayoWhite} !important;
  height: 380px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  > span {
    margin-bottom: ${({ theme }) => theme.spacing.md};
    max-width: 650px;
  }
`

const LearnAboutRolesButton = styled(Button)`
  background-color: ${({ theme }) => theme.colours.avocadoGreen};
  border-color: ${({ theme }) => theme.colours.avocadoGreen};
  color: white;
  font-size: 16px;
  padding: 8px 24px;
  height: auto;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.colours.avocadoGreen};
    border-color: ${({ theme }) => theme.colours.avocadoGreen};
    color: white;
    opacity: 0.9;
  }
`

export default PermissionBlockScreen
